module.exports = __webpack_public_path__ + "media/native-apps/katrineholm-f87b495e.webp";